import Sidebar from 'lib/components/sidebar/sidebar'

export default Sidebar
